import { useEffect, useState } from "react";
import { getNotificationSocket } from "../Services/websocket.service";

const useMentorTips = () => {
  const [mentorTips, setMentorTips] = useState<any[]>([]);

  useEffect(() => {
    const ws = getNotificationSocket();

    if (!ws) return;

    const handleMessage = (e: MessageEvent) => {
      if (e.data === "ping") return;

      try {
        const data = JSON.parse(e.data);
        const tipBlock = Array.isArray(data) ? data[0] : data;

        if (tipBlock?.type === "mentor_tips") {
          setMentorTips(tipBlock.mentor_tips || []);
        }
      } catch {
        console.error("Error parsing message:", e.data);
      }
    };

    ws.addEventListener("message", handleMessage);

    return () => {
      ws.removeEventListener("message", handleMessage);
    };
  }, []);
  return mentorTips;
};

export default useMentorTips;
